export default "__VITE_ASSET__l9wWwyDI__"